import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import RemoveLocationModal from 'modules/locations/components/RemoveLocation'

const RemoveLocationModalPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.fullPath())
  }

  return <RemoveLocationModal onClose={onClose} locationId={Number(id)} />
}

export default RemoveLocationModalPage
